import { MAX_NOTE_LENGTH, MAX_TEXT_LENGTH, validateAward } from '../../core/profile';
import type { AwardInput } from '../../core/types';
import { EntrySection, type EntryOps, type Values } from './EntryForm';

type AwardView = AwardInput & { id: string };

const toBody = (v: Values): AwardInput => {
  const year = String(v.year ?? '').trim();
  const note = String(v.note ?? '').trim();
  return { name: String(v.name ?? ''), issuer: String(v.issuer ?? ''), year: /^\d{4}$/.test(year) ? Number(year) : Number.NaN, note: note || null };
};

/** Awards (R7): name, issuer, year, and an optional short note. */
export function AwardList({ awards, ops, currentYear }: { awards: readonly AwardView[]; ops?: EntryOps<AwardInput>; currentYear: number }) {
  return <EntrySection
    heading="Awards" noun="award" entries={awards} ops={ops}
    label={(award) => award.name}
    render={(award) => <>
      <h3>{award.name}</h3>
      <p className="entry-detail">{award.issuer} · {award.year}</p>
      {award.note && <p className="entry-note">{award.note}</p>}
    </>}
    form={(award) => ({
      fields: [
        { name: 'name', label: 'Award', kind: 'text', max: MAX_TEXT_LENGTH },
        { name: 'issuer', label: 'Issuer', kind: 'text', max: MAX_TEXT_LENGTH },
        { name: 'year', label: 'Year', kind: 'year' },
        { name: 'note', label: 'Note (optional)', kind: 'textarea', max: MAX_NOTE_LENGTH },
      ],
      initial: award
        ? { name: award.name, issuer: award.issuer, year: String(award.year), note: award.note ?? '' }
        : { name: '', issuer: '', year: '', note: '' },
      validate: (v) => {
        const checked = validateAward(toBody(v), currentYear);
        return checked.ok ? null : checked;
      },
      toBody,
    })}
  />;
}
